import React from 'react';
import '../less/transfers.less'
import hero_img from '../img/money_gram_banner_img.png';
import attention_icon from '../img/wu/attention_icon.svg'
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import { ReactSVG } from 'react-svg';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import tariffs_abroad from '../../../../../../API/transfers/moneygram/tariffs_abroad.json';
import nigeriaData from '../../../../../../API/transfers/moneygram/tariffs_nigeria.json';
import turkeyEUR from '../../../../../../API/transfers/moneygram/turkey_eur.json';
import turkeyUSD from '../../../../../../API/transfers/moneygram/turkey_usd.json';
import polandUSDEUR from '../../../../../../API/transfers/moneygram/poland_eur_usd.json';
import CIStarrifs from '../../../../../../API/transfers/moneygram/cis_eur_usd.json';
import hongCongTarrifs from '../../../../../../API/transfers/moneygram/hong_cong_eur_usd.json';
import chinaOAETarrifs from '../../../../../../API/transfers/moneygram/china_oae_eur_usd.json';
import CustomDropdownNew from '../../../../../auxiliary-components/shared/CustomDropdownNew';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import { transfersAttentionUrl } from '../../../../../services/urls/urls';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'moneygram',
          isMobile = this.isViewportMobile();

    const hero_data = {
      title: 'MONEYGRAM_BANNER_TITLE',
      text: isMobile ? 'MONEYGRAM_BANNER_DESC_MOB' : 'MONEYGRAM_BANNER_DESC',
      link: null
    }

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="moneygram-new">
        <Hero
          data={hero_data}
          img={hero_img}
          className="transfers"
          page={page}
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <InfoBlock
                title={`MONEYGRAM_HOW_TO_BLOCK_TITLE`}
                text={`WU_NEW_INFO_TEXT_01`}
              />
              <div className="moneygram-new__tariffs tariffs-wu-new">
                <TitleBlock title={'MONEYGRAM_TARIFFS_TITLE'}/>
                <CustomDropdownNew title={this.l10n("MONEYGRAM_TARIFFS_CIS")} page={page} id={'tariffs-cis'}>
                  <div>
                    <TransferTableNew data={CIStarrifs}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("MONEYGRAM_TARIFFS_HONG_KONG")} page={page} id={'tariffs-hongkong'}>
                  <div>
                    <TransferTableNew data={hongCongTarrifs}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("MONEYGRAM_TARIFFS_FAR_ABROAD")} page={page} id={'tariffs-abroad'}>
                  <div>
                    <TransferTableNew data={tariffs_abroad}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("MONEYGRAM_TARIFFS_CHINA_AND_EMIRATES")} page={page} id={'tariffs-china-emirates'}>
                  <div>
                    <TransferTableNew data={chinaOAETarrifs}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("MONEYGRAM_TARIFFS_NIGERIA")} page={page} id={'tariffs-nigeria'}>
                  <div>
                    <TransferTableNew data={nigeriaData}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("MONEYGRAM_TARIFFS_TURKEY")} page={page} id={'tariffs-turkey'}>
                  <div>
                    <TransferTableNew data={turkeyEUR}/>
                    <TransferTableNew data={turkeyUSD}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("MONEYGRAM_TARIFFS_POLAND")} page={page} id={'tariffs-poland'}>
                  <div>
                    <TransferTableNew data={polandUSDEUR}/>
                  </div>
                </CustomDropdownNew>
              </div>
              <div className="moneygram-new__info-block">
                <InfoBlock
                  text={'MONEYGRAM_NEW_INFO_TEXT_02'}
                />
                <InfoBlock
                  text={'WU_NEW_INFO_TEXT_03'}
                />
                <div className="attention-block">
                  <div className="container">
                    <div className="attention-block__body">
                      <div className="attention-block__title">
                        <ReactSVG src={attention_icon} className="attention-block__icon"/>
                        {this.l10n('MONEYGRAM_HINT_TITLE')}
                      </div>
                      <div className="attention-block__text">
                        <ul>
                          <li>{this.l10n('MONEYGRAM_HINT_LIST_ITEM_1')}</li>
                          <li>{this.l10n('MONEYGRAM_HINT_LIST_ITEM_2')}</li>
                          <li>{this.l10n('MONEYGRAM_HINT_LIST_ITEM_3')}</li>
                          <li>{this.l10n('MONEYGRAM_HINT_LIST_ITEM_4')}</li>
                          <li>{this.l10n('MONEYGRAM_HINT_LIST_ITEM_5')}</li>
                          <li>{this.l10n('MONEYGRAM_HINT_LIST_ITEM_6')}</li>
                          <li>{this.l10n('MONEYGRAM_HINT_LIST_ITEM_7')}</li>
                          <li>
                            {this.l10n('MONEYGRAM_HINT_LIST_ITEM_8_1')}
                            <a href={transfersAttentionUrl} target='_blank' rel='noopener noreferrer'>{this.l10n('MONEYGRAM_HINT_LIST_ITEM_8_2')}</a>
                          </li>
                        </ul>
                        <p>
                          {this.l10n('MONEYGRAM_NEW_ATTENTION_BLOCK_TEXT_01')}
                          <a href="/about/general" target='_self' onClick={(e) => this.navigate("/about/general", e)}>{this.l10n('MONEYGRAM_NEW_ATTENTION_BLOCK_LINK_01')}</a>
                        </p>
                        <p>
                          {this.l10n('MONEYGRAM_NEW_ATTENTION_BLOCK_TEXT_02')}
                          <a href="/forpartners" target='_self' onClick={(e) => this.navigate("/forpartners", e)}>{this.l10n('MONEYGRAM_NEW_ATTENTION_BLOCK_LINK_02')}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <QuestionsAdminNew
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'FAQ_SHORT_NEW_TITLE'}
                page={page}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
      </div>
    );
}